import { render, staticRenderFns } from "./MSview.vue?vue&type=template&id=20dcb5a6"
import script from "./MSview.vue?vue&type=script&lang=js"
export * from "./MSview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports